// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2_GTd","log":"ModalInventoryLogs_log__2EBMB","date":"ModalInventoryLogs_date__mKqgo","userName":"ModalInventoryLogs_userName__2s3yp"};